import * as React from "react";
import styles from "./styles.scss";

type Props = {
  children: React.ReactNode;
};
export const TagFilterSelectedTagsArea = ({ children }: Props) => (
  <div className={styles.root}>{children}</div>
);
